import { GeneratorBackgroundIcon } from '@/components/Icons';
import Show from '@/components/Show';
import useGeneratorStore, { GeneratorTypeEnums } from '@/state/generator-store';
import React from 'react';
import AudioEditor from '../AudioEditor';
import GeneratorSwitch from './GeneratorSwitch';

const DetailEffects: React.FC = () => {
  const { generatorType } = useGeneratorStore((state) => ({
    generatorType: state.generatorType,
    setIsGeneratorDrawerShow: state.setIsGeneratorDrawerShow,
  }));

  return (
    <div className="flex text-white py-6 px-3 w-full">
      <Show when={generatorType === GeneratorTypeEnums.R3IMAGINE || generatorType === GeneratorTypeEnums.TEXT}>
        <div className="w-1/8 flex flex-col justify-center items-center py-0">
          <div className="flex flex-col items-center w-full h-full justify-center px-2">
            <div className="flex flex-col justify-between h-full">
              <div className="flex-1 flex justify-center items-center">
                <GeneratorSwitch />
              </div>
            </div>
          </div>
        </div>
      </Show>
      <Show when={generatorType === GeneratorTypeEnums.EDITOR}>
        <AudioEditor />
      </Show>
      <Show when={generatorType !== GeneratorTypeEnums.EDITOR}>
        <div className="xm:hidden xl:w-1/8 2xl:w-1/6 h-full flex justify-end">
          <div className="xl:scale-75">
            <GeneratorBackgroundIcon />
          </div>
        </div>
      </Show>
    </div>
  );
};

export default DetailEffects;
